import { useConnect } from 'redux-bundler-hook'

import { getDateTime } from '~/src/Lib/Utils'

const useCanEditTask = phaseId => {
  const {
    phases,
    routeInfo,
    dialogRouteInfo
  } = useConnect('selectPhases', 'selectRouteInfo', 'selectDialogRouteInfo')
  const phaseEndDate = phases[phaseId]?.endDate
  if (routeInfo.url && routeInfo.url.includes('recipes')) return true
  if (dialogRouteInfo.url && dialogRouteInfo.url.includes('/tasks/')) return true
  return Boolean(phaseEndDate && getDateTime(phaseEndDate) > getDateTime('now'))
}

export default useCanEditTask
